import React from "react";
import Reveal from "../../Reveal";
import { useI18n } from "../../../i18n/LanguageContext";
import { SITE } from "../../../content/site";

export default function EventTechnology() {
  const { lang } = useI18n();
  const c = (SITE[lang].homeStory || SITE.en.homeStory).technology;
  const chips = (SITE[lang].events || SITE.en.events).technology.items;

  return (
    <section data-testid="home-technology" className="bg-[#f6f5f2] px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid items-center gap-14 lg:grid-cols-12 lg:gap-10">
          <div className="min-w-0 lg:col-span-5">
            <Reveal><p className="overline text-[#0e7c6b]">{c.overline}</p></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display mt-7 text-3xl font-light leading-[1.05] tracking-tightest text-[#050505] md:text-5xl">{c.title}</h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 max-w-lg text-base font-light leading-relaxed text-[#4a4a4a] md:text-lg">{c.text}</p>
            </Reveal>
            <Reveal delay={0.3}>
              <p className="mt-8 max-w-lg border-l-2 border-[#0e7c6b] pl-5 text-base font-light leading-relaxed text-[#2a2b29]">{c.note}</p>
            </Reveal>
          </div>

          {/* Realistic operations console */}
          <div className="min-w-0 lg:col-span-7">
            <Reveal delay={0.15}>
              <div data-testid="tech-console" className="overflow-hidden rounded-2xl border border-black/10 bg-white shadow-[0_30px_80px_-30px_rgba(5,5,5,0.25)]">
                <div className="flex items-center justify-between gap-4 border-b border-black/8 bg-[#fafafa] px-6 py-4">
                  <div className="flex items-center gap-4">
                    <span className="flex gap-1.5">
                      <span className="h-2.5 w-2.5 rounded-full bg-[#e0ddd6]" />
                      <span className="h-2.5 w-2.5 rounded-full bg-[#e0ddd6]" />
                      <span className="h-2.5 w-2.5 rounded-full bg-[#e0ddd6]" />
                    </span>
                    <p className="text-sm font-medium text-[#050505]">{c.uiTitle}</p>
                  </div>
                  <span className="rounded-full bg-[#0e7c6b]/10 px-3 py-1 text-[11px] font-medium text-[#0e7c6b]">{c.uiTag}</span>
                </div>
                <div className="divide-y divide-black/6">
                  {c.modules.map((m, i) => (
                    <div key={m.k} data-testid={`tech-module-${i}`}
                      className="group flex items-center gap-5 px-6 py-4 transition-colors hover:bg-[#f6f5f2] md:px-8 md:py-5">
                      <span className="h-2 w-2 shrink-0 rounded-full bg-[#0e7c6b]" />
                      <div className="min-w-0 flex-1">
                        <p className="text-sm font-medium text-[#050505] md:text-base">{m.k}</p>
                        <p className="mt-0.5 text-xs font-light text-[#8a8d88] md:text-sm">{m.s}</p>
                      </div>
                      <span className="font-display text-xs tracking-[0.2em] text-[#c9c5bc]">{String(i + 1).padStart(2, "0")}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.2}>
          <ul className="mt-16 flex flex-wrap gap-2.5">
            {chips.map((it) => (
              <li key={it} className="rounded-full border border-black/12 px-4 py-2 text-sm font-light text-[#2a2b29]">{it}</li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
